export const typesErrorComponent = Object.freeze({
  PAGE_NOT_FOUND: 'PAGE_NOT_FOUND',
  NO_INTERNET: 'NO_INTERNET',
  SOMETHING_WRONG: 'SOMETHING_WRONG',
  ACCESS_DENIED: 'ACCESS_DENIED',
  NOT_FOUND_SEARCH: 'NOT_FOUND_SEARCH',
  NOT_INSTAGRAM_ACCOUNT: 'NOT_INSTAGRAM_ACCOUNT',
});
